/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconAstronaut1 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M5.962 10.425l2.652-2.652M17.364 1.261a4.125 4.125 0 1 1 0 8.25 4.125 4.125 0 0 1 0-8.25z" />
        <path d="M5.432 19.44l2.652-2.651a1.5 1.5 0 1 0-2.122-2.122l-2.651 2.652A1.5 1.5 0 0 1 1.189 15.2l4.773-4.773A1.502 1.502 0 0 1 3.841 8.3l3.182-3.179a3 3 0 0 1 4.243 0s0 0 0 0l6.364 6.364a3 3 0 0 1 0 4.243s0 0 0 0l-3.182 3.182a1.5 1.5 0 1 1-2.122-2.122l-4.773 4.773a1.5 1.5 0 1 1-2.121-2.121h0zM14.978 14.137l-2.652 2.652" />
        <path d="M7.023 5.121l3.712-3.712a2.25 2.25 0 0 1 3.181-.001l.001.001.808.807M17.63 15.728l3.712-3.712a2.25 2.25 0 0 0 .001-3.181l-.001-.001-.808-.808M11.62 9.718l1.414 1.414a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 0-.707l1.414-1.414a.499.499 0 0 1 .707 0zM20 8.557a7.362 7.362 0 0 0-1.84-3.966 7.368 7.368 0 0 0-3.966-1.844M9.545 19.57l.569.654a8.816 8.816 0 0 0 13.136.176" />
      </g>
    </svg>
  ),
);
